<template>
	<div>
		<!-- <MyBread v-bind:BreadcrumbList="BreadcrumbList"></MyBread> -->
		<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
			<!-- <FormItem prop="trackName" label="充电站:" :label-width="70">
				<Select placeholder="站点列表" style="width: 120px;" v-model="formInline.StationId">
					<Option :value=0>全部</Option>
					<Option v-bind:key="item.StationId" v-for="(item) in StationList" :value="item.StationId">{{item.StationName}}</Option>
				</Select>
			</FormItem> -->
			<!-- <FormItem prop="trackName" label="启动方式" :label-width="70">
				<Select placeholder="启动方式" style="width: 100px;" v-model="formInline.StartMode">
					<Option :value='-1'>全部</Option>
					<Option :value='0'>离线充电卡</Option>
					<Option :value='1'>在线充电卡</Option>
					<Option :value='2'>本地VIN码</Option>
					<Option :value='3'>在线VIN码</Option>
					<Option :value='4'>物理按键启动</Option>
					<Option :value='5'>屏幕启动</Option>
					<Option :value='6'>本地预约充电</Option>
					<Option :value='7'>平台预约充电</Option>
					<Option :value='48'>平台</Option>
				</Select>
			</FormItem> -->
			<!-- <FormItem prop="trackName">
				<Input type="text" v-model="formInline.OrderNo" style="width: 180px;" placeholder="订单单号">
				<span slot="prepend">订单单号</span>
				</Input>
			</FormItem> -->
			<!-- <FormItem label="开始时间" :label-width='70'>
				<DatePicker style="width: 110px;" type="date" format="yyyy-MM-dd" placeholder="Select date"
					v-model="formInline.TimeBegin"></DatePicker>
			</FormItem> -->
			<!-- <FormItem label="结束时间" :label-width='70'>
				<DatePicker style="width: 110px;" type="date" format="yyyy-MM-dd" placeholder="Select date"
					v-model="formInline.TimeEnd"></DatePicker>
			</FormItem> -->
			<FormItem label="选择时间" :label-width='70'>
				<DatePicker style="width: 210px;" type="daterange" format="yyyy-MM-dd" placeholder="Select date"
					v-model="formInline.TimeRange" @on-change="handleChange"></DatePicker>
			</FormItem>
			<!-- <FormItem>
				<Input type="text" v-model="formInline.MemberName" placeholder="会员名称">
				<span slot="prepend">会员名称</span>
				</Input>
			</FormItem> -->
			<!-- <FormItem>
				<Input type="text" v-model="formInline.EquipmentNo" style="width: 180px;" placeholder="设备编号">
				<span slot="prepend">设备编号</span>
				</Input>
			</FormItem> -->
			<FormItem prop="trackName">
				<Input type="text" style="width: 180px;" v-model="formInline.EquipmentSerialNo" placeholder="设备序列号">
					<span slot="prepend">设备序列号</span>
				</Input>
			</FormItem>
			<FormItem prop="trackName">
				<Input type="text" style="width: 180px;" v-model="formInline.ProductBatchNo" placeholder="生产批次号">
					<span slot="prepend">生产批次号</span>
				</Input>
			</FormItem>
			<FormItem prop="trackName" label="测试结果" :label-width="70">
				<Select placeholder="测试结果" style="width: 100px;" v-model="formInline.Status">
					<Option :value='0'>全部</Option>
					<Option :value='1'>成功</Option>
					<Option :value='2'>失败</Option>
				</Select>
			</FormItem>
			<FormItem prop="trackName">
				<Input type="text" style="width: 180px;" v-model="formInline.MachineCode1" placeholder="机器码1">
					<span slot="prepend">机器码1</span>
				</Input>
			</FormItem>
			<FormItem prop="trackName">
				<Input type="text" style="width: 180px;" v-model="formInline.MachineCode2" placeholder="机器码2">
					<span slot="prepend">机器码2</span>
				</Input>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">查询</Button>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="exportFile" v-if="hasWidgets('export')">导出文件</Button>
			</FormItem>
		</Form>
		<!-- <Table :row-class-name="rowClassName" :columns="columns1" :data="data1" :height="tableHeight" ref="ChargingOrder" size="small">
			<MyPage slot="footer" ref="sonPage" :param="pageParam" :url="getRecordUrl" @listData='getDeviceData'></MyPage>
		</Table> -->
		<PageTable ref="ChargingOrder" :columns="columns1" :tableHeight="tableHeight" :url="getRecordUrl" :queryParam="pageParam"></PageTable>
		<!-- <echartModal ref="echartModal" curvesName="ChargeRecord"></echartModal> -->
		<Modal :mask-closable="false" v-model="modalView" title="测试明细" width="70%">
			<Table :row-class-name="rowClassName" :loading="tableLoadingDetail" :columns="DetailColumns" :data="DetailData"  ref="testDetailTalbe" size="small">
			</Table>
		</Modal>
	</div>
</template>

<script>
	import dateFormat from '../../../../public/js/comm.js'
	// import echartModal from '../../public/CurvesTemplate/ChargingOrderEchart.vue'
	import PageTable from '../../public/PageTable/PageTable.vue';
	import Qs from 'qs'
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../../webapi.js'
	export default {
		components: {
			PageTable
		},
		data() {
			return {
				getRecordUrl: webapi.base_api_url + '/BoardTest/GetBoardTestRecord',
				loadingStatus: false,
				//model表单
				params: "", //table 传参
				//选择展示的充电站
				SelectStation: "",
				tableHeight: "650",
				modal: {
					Title: "设备信息添加",
					type: "addDevice"
				},
				BreadcrumbList: ['主板信息', '>>', '测试记录'],
				formInline: {
					StationId: 0,
					// OrderNo: '',
					TimeBegin: dateFormat.formatDate(new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 30), 'yyyy-MM-dd'),
					TimeEnd: dateFormat.formatDate(new Date(), 'yyyy-MM-dd'),
					TimeRange: [new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 30), new Date()],
					// MemberName: '',
					// EquipmentNo: '',
					ProductBatchNo: '',
					// StartMode: -1
					EquipmentSerialNo: '',
					Status: 0,
					MachineCode1: '',
					MachineCode2: '',
				},
				//table标题数据
				columns1: [
					{
						title: '序号',
						type: 'index',
						width: 80
					},
					// {
					// 	title: '设备编码',
					// 	key: 'ConnectorNo',
					// 	// fixed: 'left',
					// 	minWidth: 100
					// },
					{
						title: '生产批次号',
						key: 'ProductionBatch',
						minWidth: 160
					},
					{
						title: '机器码1',
						key: 'MachineCode1',
						minWidth: 180
					},
					{
						title: '机器码2',
						key: 'MachineCode2',
						minWidth: 180
					},
					// {
					// 	title: '设备序列号',
					// 	key: 'EquipmentSerialNo',
					// 	minWidth: 160
					// },
					// {
					// 	title: '设备编码',
					// 	key: 'EquipmentNo',
					// 	// fixed: 'left',
					// 	minWidth: 100
					// },
					{
						title: '测试次数',
						key: 'TestNum',
						minWidth: 100,
					},
					{
						title: '测试结果',
						key: 'TestResult',
						minWidth: 100,
						render: (h, params) => {
							return h('Tag',
								{
									props: {
										color: params.row.TestResult == 1 ? 'success' : 'warning'
									}
								},
								params.row.TestResult == 1 ? '成功' : '失败'
							);
						}
					},
					{
						title: '测试时间',
						key: 'ReportTime',
						minWidth: 110
					},
					{
						title: '操作',
						key: 'action',
						width: 100,
						render: (h, params) => {
							return h('div', [
								this.hasWidgets('view') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										//为了不误操作，确定取消相反
										click: () => {
											this.showDetailModal(params.row)
										}
										// this.show("deleteStation", params.row.Id)
									}
								}, '查看明细') : h(),
							]);
						}
					}
				],
				data1: [],
				modalView: false,
				tableLoadingDetail: false,
				DetailColumns: [
					{
						title: '序号',
						type: 'index',
						width: 80
					},
					// {
					// 	title: '设备编码',
					// 	key: 'ConnectorNo',
					// 	// fixed: 'left',
					// 	minWidth: 100
					// },
					{
						title: '测试结果',
						key: 'TestResult',
						minWidth: 100,
						render: (h, params) => {
							return h('Tag',
								{
									props: {
										color: params.row.TestResult == 1 ? 'success' : 'warning'
									}
								},
								params.row.TestResult == 1 ? '成功' : '失败'
							);
						}
					},
					{
						title: '生产批次号',
						key: 'ProductionBatch',
						minWidth: 160
					},
					{
						title: '机器码1',
						key: 'MachineCode1',
						minWidth: 180
					},
					{
						title: '机器码2',
						key: 'MachineCode2',
						minWidth: 180
					},
					{
						title: '测试时间',
						key: 'ReportTime',
						minWidth: 110
					},
				],
				DetailData: [],
			};
		},
		created() {
			const _this = this;
			// _this.tableHeight = window.innerHeight - 160;
			_this.getTableHeight();
			window.addEventListener('resize', this.getTableHeight)
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			this.handleSubmit();
		},
		computed: {
			pageParam: function() {
				const _this = this;
				// const param = {
				// 	StationId: _this.formInline.StationId,
				// 	OrderNo: _this.formInline.OrderNo,
				// 	TimeBegin: _this.formInline.TimeBegin == '' ? '' : dateFormat.formatDate(new Date(_this
				// 		.formInline.TimeBegin), 'yyyy-MM-dd'),
				// 	
				// 	MemberName: _this.formInline.MemberName,
				// 	EquipmentNo: _this.formInline.EquipmentNo
				// }
				let param = _this.formInline;
				param.TimeBegin = _this.formInline.TimeBegin == '' ? '' : dateFormat.formatDate(new Date(_this
					.formInline.TimeBegin), 'yyyy-MM-dd');
				param.TimeEnd = _this.formInline.TimeEnd == '' ? '' : dateFormat.formatDate(new Date(_this.formInline
					.TimeEnd), 'yyyy-MM-dd');
				return param
			},
			//直接选属性
			...mapState({
				StationList: 'Stations'
			})
		},
		watch: {},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			handleChange(date, type) {
				console.log("日期改变：", date, type);
				this.formInline.TimeBegin = date[0];
				this.formInline.TimeEnd = date[1];
			},
			exportFile: function() {
				this.$refs.ChargingOrder.exportCsv(tableData => {
					return {
						filename: '主板测试记录',
						data: tableData.map(k => {
							k.MachineCode1 = "\t" + k.MachineCode1;
							k.MachineCode2 = "\t" + k.MachineCode2;
							// k.OrderTime = '\t' + (k.OrderTime || '');
							k.StartTime = '\t' + (k.StartTime || '');
							k.EndTime = '\t' + (k.EndTime || '');
							// k.RefundTime = '\t' + (k.RefundTime || '');
							return k;
						})
					};
				});
			},
			rowClassName: function(row, index) {
				if (index % 2 == 0) {
					return 'demo-table-info-row';
				} else if (index % 2 == 1) {
					return 'demo-table-error-row';
				}
				return '';
			},
			//操作
			showDetailModal: function(row) {
				this.DetailData = [];
				this.modalView = true;
				this.tableLoadingDetail = true;
				this.$axios.post(webapi.base_api_url + '/BoardTest/GetBoradTestRecordDetail', { MachineCode2: row.MachineCode2 }).then(res => {
					if (res.data.Code == 0) {
						this.DetailData = res.data.Data.List;
					}
				}).finally(() => {
					this.tableLoadingDetail = false;
				});
			},
			//Page组件回调
			getDeviceData: function(data) {
				console.log(data)
				this.data1 = data.Data.List
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				// this.$refs.sonPage.getList();
				this.$refs.ChargingOrder.getData();
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 160 - (window.innerWidth < 1522 ? 40 : 0);
			},
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}
</style>
